import { render, staticRenderFns } from "./SearchCard.vue?vue&type=template&id=16cbea9c&scoped=true&"
import script from "./SearchCard.vue?vue&type=script&lang=js&"
export * from "./SearchCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cbea9c",
  null
  
)

export default component.exports